import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';

export class TextAreaOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**
 *   Represent classes to textbox that allow us to select the TextArea by jquery or javascript 
 */
 
  ExtraClasses:string

 /**  Represent value of the label*/
  LabelValue:string
   /**  Represent Key of the label*/
   LabelKey:string
  /**  Represent value of the labelDescription show under TextArea*/
  LabelDescription:string
  /** Represent value of the Placeholder of TextArea */
  Placeholder:string
  /**To set  value  to TextArea */
  Value:string
  //** Set the MaxLength of characters In TextArea */
  MaxLength?:number
  /**Set the MinLength of characters In TextArea  */
  MinLength?:number
  /**Set Number Of Rows  */
  Rows:number
   //** Set the MaxWordCount of characters In TextArea */
   MaxWordCount: number;

  /**Prevent AutoComplete of TextArea*/
  AutoComplete:boolean
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  TextArea required */
  IsRequired: boolean
  /** Ability to display or hide the label of TextArea */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  /**  text input on change  */ 
  TrimTextOnChange: boolean
  /** add button to for coping to clipboard */
  EnableCopyToClipboard: boolean
  /**  to set type of view  if TextArea is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
  CustomValidation: CustomValidation[]=[]
  /** to set Direction of TextArea  if TextArea is Arabic or English  */
  ForceDirection: ForceDirection=ForceDirection.English
  /** Set List of Custom Attribute to TextArea  */
  AttributeList:Attribute[]

}